import { render, staticRenderFns } from "./wxOrder.vue?vue&type=template&id=0b783dee&scoped=true&"
import script from "./wxOrder.vue?vue&type=script&lang=js&"
export * from "./wxOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b783dee",
  null
  
)

export default component.exports